
import { defineComponent } from "vue";

export default defineComponent({
  name: "CategoriesButton",

  props: {
    text: {
      type: String,
      required: true,
    },
  },

  setup(props, { emit }) {
    const buttonClick = (category: string) => {
      emit("changeCategory", category);
    };

    return { buttonClick };
  },
});
